export const CM = 'CM'
export const DM = 'DM'
export const M = 'M'
export const MM = 'MM'

const titles = {
    [CM]: 'см.',
    [DM]: 'дм.',
    [M]: 'м.',
    [MM]: 'мм.'
}

export const getLength = (type) => {
    return titles[type]
}